/*eslint-disable @typescript-eslint/no-unsafe-return */
/*eslint-disable @typescript-eslint/no-unused-vars */
/*eslint-disable @typescript-eslint/no-unsafe-member-access */
/*eslint-disable @typescript-eslint/no-unsafe-argument */
import { api } from 'src/common/utils';

import {
  BrandProps,
  LegalEntityProps,
  RequestApiPaginationResponseType,
  RequestCreateTcrBrandResponseType,
} from '../../types';

export const fetchLegalEntities = async (
  filter: {
    name: string;
    account: string;
  },
  currentPage: number
): Promise<RequestApiPaginationResponseType<LegalEntityProps>> => {
  let url = `/legal_entities?page=${currentPage}`;
  const searchParams = Object.entries(filter)
    .filter(([key, value]) => value !== '' && value !== undefined)
    .map(([key, value]) => (value ? `${encodeURIComponent(value)}` : ''))
    .join(',');
  if (searchParams) {
    url += `&search=${searchParams}`;
  }
  const response: RequestApiPaginationResponseType<LegalEntityProps> = await api.get(url);
  return response;
};

export const createTcrBrand = async (
  legalEntity: LegalEntityProps
): Promise<RequestCreateTcrBrandResponseType> => {
  const url = '/campaign_management/tcr_brands/create_tcr_brand';
  const data = {
    legal_entity_id: legalEntity.id,
  };
  const response = await api.post(url, data);
  return response;
};

export const updateTcrBrand = async (
  brand: BrandProps
): Promise<RequestCreateTcrBrandResponseType> => {
  const url = '/campaign_management/tcr_brands/update_tcr_brand';
  const data = {
    brand_uuid: brand.id,
  };
  const response = await api.post(url, data);
  return response;
};
